// Copyright © 2019-2026 Focal Systems. All rights reserved.

import { Link } from "@tanstack/react-router";
import { ShieldOff } from "lucide-react";
import { useTranslation } from "react-i18next";
import { PageHeader } from "@/components/layout/page-header";
import { Button } from "@/components/ui/button";

interface AccessDeniedProps {
  permission?: string;
}

export function AccessDenied({ permission }: AccessDeniedProps) {
  const { t } = useTranslation("back-office");
  return (
    <div>
      <PageHeader title={t("accessDenied.title")} icon={ShieldOff} />
      <div className="flex flex-col items-center justify-center gap-4 py-24 px-6 text-center">
        <div className="flex h-16 w-16 items-center justify-center rounded-full bg-muted text-muted-foreground">
          <ShieldOff className="h-8 w-8" />
        </div>
        <div className="space-y-1">
          <h2 className="text-lg font-semibold">{t("accessDenied.title")}</h2>
          <p className="text-sm text-muted-foreground">{t("accessDenied.description")}</p>
          {permission && (
            <p className="pt-2 text-xs text-muted-foreground font-mono">
              {t("accessDenied.missingPermission", { permission })}
            </p>
          )}
        </div>
        <Button asChild variant="outline">
          <Link to="/chains">{t("accessDenied.backToHome")}</Link>
        </Button>
      </div>
    </div>
  );
}
